import { atom } from "recoil";
export const rawdhasAtoms = atom({
  key: "rawdhasAtoms", // unique ID (with respect to other atoms/selectors)
  default: [], // default value (aka initial value)
});
